import FieldController from '../field.controller';

class MultiSelectCheckboxFieldController extends FieldController {
  constructor($scope, $q, $translate, $log) {
    "ngInject";
    super($scope, $q, $translate, $log);
  }

  get optionsWithSelected() {
    if (this._optionsWithSelected === undefined) {
      let selectedOptionIds = this.value
        && this.value.toString().split(/[|,]/).map(id => parseInt(id))
        || [];
      this._optionsWithSelected = this.options.map(option => {
        let selected = selectedOptionIds.indexOf(parseInt(option.id)) !== -1;
        return {option, selected};
      });
    }
    return this._optionsWithSelected;
  }

  set optionsWithSelected(optionsWithSelected) {
    this._optionsWithSelected = optionsWithSelected;
  }

  updateResponseValue() {
    let selectedOptionIds = this.optionsWithSelected
      .filter(o => o.selected)
      .map(o => o.option.id);
    this.value = selectedOptionIds.join('|');
  }
}

export default MultiSelectCheckboxFieldController;
